const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'RESET_APM_ZABBIX_ITEMS') {
        return initialState;
    }

    if (action.type === 'APM_TEMPERATURES_SUCCESS') {
        const errors = action.payload.errors.reduce((res, error) => {
            // 501 only
            if (error.towerId === undefined) {
                const [, type, ids] = /sensor (.+?)([0-9,]+)/.exec(error) ?? [];

                ids?.split(',').forEach(id => {
                    const index = `${type}${id}`;
                    res[index] = [...(res[index] ?? []), error];
                });
            }

            return res;
        }, {});

        return {
            ...action.payload,
            // 501 only
            sensors: action.payload.sensors?.map(sensor => {
                const [type, id] = [sensor.index.slice(0, 1), +sensor.index.slice(1)];

                return {
                    ...sensor,
                    hasError: !!errors[sensor.index],
                    id,
                    type,
                    value:
                        type === 'T'
                            ? action.payload.temperatures[id]
                            : action.payload.humidities[id],
                    zone: action.payload.towers.find(tower => tower.id === sensor.tower)?.zone,
                };
            }),
        };
    }

    return state;
}

export default reducer;
